import { render } from "./ManageAppointments.vue?vue&type=template&id=0b38ba70&scoped=true"
import script from "./ManageAppointments.vue?vue&type=script&lang=js"
export * from "./ManageAppointments.vue?vue&type=script&lang=js"

import "./ManageAppointments.vue?vue&type=style&index=0&id=0b38ba70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b38ba70"]])

export default __exports__